import React from 'react';
import { HeartPulseIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
// Mock data
const healthEvents = [{
  id: 1,
  date: 'Feb 10',
  title: 'First Vet Visit',
  description: 'Complete check-up and first round of vaccinations',
  icon: 'checkup'
}, {
  id: 2,
  date: 'Apr 15',
  title: 'Vaccinations',
  description: 'Second round of core vaccinations completed',
  icon: 'vaccine'
}, {
  id: 3,
  date: 'Jul 22',
  title: 'Microchipped',
  description: 'Successfully microchipped for safety',
  icon: 'chip'
}, {
  id: 4,
  date: 'Oct 5',
  title: 'Annual Check-up',
  description: 'Perfect health! Weight and growth on track',
  icon: 'checkup'
}, {
  id: 5,
  date: 'Dec 12',
  title: 'Dental Check',
  description: 'First dental cleaning - teeth look great!',
  icon: 'dental'
}];
interface HealthHighlightsProps {
  petName: string;
}
export const HealthHighlights = ({
  petName
}: HealthHighlightsProps) => {
  return <section className="rounded-2xl p-5 sm:p-8 bg-white shadow-[0_10px_60px_-15px_rgba(0,0,0,0.1)] relative overflow-hidden" data-id="element-38">
      <div className="absolute top-0 left-0 w-32 sm:w-40 h-32 sm:h-40 bg-blue-100 rounded-full opacity-40 -ml-16 sm:-ml-20 -mt-16 sm:-mt-20" data-id="element-39"></div>
      <div className="absolute bottom-0 right-0 w-24 sm:w-32 h-24 sm:h-32 bg-blue-100 rounded-full opacity-40 -mr-8 sm:-mr-10 -mb-8 sm:-mb-10" data-id="element-40"></div>
      <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8 relative" data-id="element-41">
        <div className="bg-gradient-to-br from-blue-400 to-blue-600 p-2.5 sm:p-3 rounded-xl shadow-md" data-id="element-42">
          <HeartPulseIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-43" />
        </div>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800" data-id="element-44">
          Health Highlights
        </h2>
      </div>
      <p className="text-gray-700 mb-6 sm:mb-8 text-base sm:text-lg max-w-2xl" data-id="element-45">
        {petName} had a healthy year with all these important milestones!
      </p>
      <div className="grid grid-cols-1 gap-4 sm:gap-6" data-id="element-46">
        {healthEvents.map(event => <div key={event.id} className="bg-gradient-to-br from-white to-blue-50 rounded-xl p-4 sm:p-5 flex items-start shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1" data-id="element-47">
            <div className="bg-gradient-to-br from-blue-400 to-blue-600 text-white rounded-xl w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shrink-0 mr-3 sm:mr-4 shadow-md" data-id="element-48">
              <ShieldCheckIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-49" />
            </div>
            <div className="flex-1" data-id="element-50">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 sm:gap-0" data-id="element-51">
                <h3 className="font-semibold text-gray-800 text-base sm:text-lg" data-id="element-52">
                  {event.title}
                </h3>
                <span className="text-xs sm:text-sm bg-blue-100 text-blue-700 px-2.5 py-1 sm:px-3 sm:py-1 rounded-full font-medium w-fit" data-id="element-53">
                  {event.date}
                </span>
              </div>
              <p className="text-gray-600 mt-1.5 sm:mt-2 text-sm sm:text-base" data-id="element-54">
                {event.description}
              </p>
            </div>
          </div>)}
      </div>
      <div className="mt-8 sm:mt-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-4 sm:p-5 text-center shadow-md" data-id="element-55">
        <span className="text-white font-semibold text-base sm:text-lg" data-id="element-56">
          {petName} had 5 vet visits and is in perfect health!
        </span>
      </div>
    </section>;
};